<template>

  <div :class="{'box-loading': loading}">
    <div
      v-if="notFind" 
      class="alert alert-warning">
      Nenhum workflow encontrado
      </div>

    <Approvalflow
      :approvalflowId="approvalflowId"
      @redefined="redefinedApprovalflow" />
  </div>

</template>

<script>
import Approvalflow from '@/components/Approvalflow/Approvalflow'

export default {
  name: 'RequisitionApprovalflow',
  components: {
    Approvalflow
  },
  data () {
    return {
      loading: false,
      notFind: false
    }
  },
  computed: {
    requisition () {
      return this.$store.getters.getRequisition
    },
    approvalflowId () {
      return this.requisition.approvalflow ? this.requisition.approvalflow._id : null
    }
  },
  created () {
  },
  methods: {
    redefinedApprovalflow () {
      this.loading = true

      this.$store
      .dispatch('redefinedRequisitionApprovalflow', this.requisition._id)
      .then(result => {
        this.notFind = !result
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Requisition/RequisitionApprovalflow.vue